import * as React from 'react'
import styled from 'styled-components'

import * as colors from '../../../../constants/colors'
import { lightweight, standalone, SymbolProps } from '../../../spritesheetUtils'
import * as illustration from '../../Illustration'

const ID = 'certificate-illustration-icon'

export function CertificateSymbol({ id = ID, ...props }: SymbolProps): React.ReactElement<SymbolProps> {
  return (
    <symbol {...props} id={id} viewBox="0 0 30 34">
      <g>
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M15.9946 7.77775C16.311 7.67909 16.6373 7.71864 16.9093 7.86241C17.1813 8.00617 17.3991 8.25415 17.498 8.57165L22.4292 24.4822C22.5282 24.8 22.4898 25.1281 22.3476 25.4015C22.2053 25.6752 21.9592 25.8941 21.6437 25.9933L9.21918 29.887C8.90276 29.9857 8.57645 29.9461 8.30445 29.8023C8.03245 29.6586 7.81472 29.4106 7.71578 29.0931L2.78459 13.1825C2.68555 12.8647 2.72403 12.5367 2.86617 12.2633C3.00845 11.9896 3.25457 11.7706 3.57005 11.6714L15.9946 7.77775Z"
          fill="currentColor"
          stroke="currentColor"
          strokeWidth="2"
        />
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M7.02243 13.7491L14.8497 11.2918C15.1447 11.1997 15.4579 11.3644 15.5499 11.6602L15.5883 11.7839C15.6804 12.0799 15.5155 12.3952 15.2205 12.4881C15.2204 12.4881 15.2202 12.4882 15.2199 12.4878L7.39266 14.945C7.09761 15.0371 6.78445 14.8724 6.6924 14.5766L6.65409 14.4529C6.56199 14.1569 6.72684 13.8416 7.02185 13.7488C7.022 13.7487 7.02214 13.7487 7.02243 13.7491Z"
          fill="currentColor"
        />
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M7.76071 16.1495L15.588 13.6922C15.883 13.6001 16.1962 13.7648 16.2882 14.0606L16.3265 14.1843C16.4186 14.4803 16.2538 14.7956 15.9588 14.8885C15.9586 14.8885 15.9585 14.8886 15.9582 14.8882L8.13094 17.3454C7.8359 17.4375 7.52273 17.2728 7.43069 16.977L7.39237 16.8533C7.30027 16.5573 7.46512 16.242 7.76013 16.1491C7.76028 16.1491 7.76043 16.1491 7.76071 16.1495Z"
          fill="currentColor"
        />
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M8.5068 18.5491L16.3341 16.0919C16.6291 15.9997 16.9423 16.1645 17.0343 16.4602L17.0726 16.584C17.1647 16.8799 16.9999 17.1952 16.7049 17.2881C16.7047 17.2882 16.7046 17.2882 16.7043 17.2878L8.87704 19.745C8.58199 19.8372 8.26882 19.6725 8.17678 19.3767L8.13847 19.2529C8.04637 18.957 8.21122 18.6417 8.50623 18.5488C8.50637 18.5488 8.50652 18.5487 8.5068 18.5491Z"
          fill="currentColor"
        />
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M13.6983 19.5539L17.0782 18.4921C17.3733 18.3999 17.6865 18.5648 17.7786 18.8608L17.8169 18.9846C17.909 19.2808 17.7442 19.5964 17.4491 19.6893C17.449 19.6894 17.4488 19.6894 17.4485 19.689L14.0686 20.7507C13.7735 20.843 13.4603 20.6781 13.3682 20.3821L13.3299 20.2582C13.2378 19.9621 13.4027 19.6465 13.6977 19.5536C13.6979 19.5535 13.698 19.5535 13.6983 19.5539Z"
          fill="currentColor"
        />
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M25.7609 9.32833L26.8235 18.3425C26.8365 18.4529 26.8038 18.558 26.7405 18.6389C26.6772 18.7198 26.5832 18.7763 26.4736 18.7893C26.3743 18.8011 26.2742 18.775 26.1931 18.7162L23.5627 16.81C23.4214 16.7077 23.2569 16.652 23.0901 16.6441C22.9233 16.6361 22.7544 16.6759 22.6043 16.7644L19.7531 18.4455C19.6578 18.5017 19.549 18.5137 19.45 18.4876C19.351 18.4616 19.2618 18.3975 19.206 18.3016C19.157 18.2175 19.14 18.1183 19.1582 18.0225L20.8515 9.09467L25.7609 9.32833Z"
          fill="currentColor"
          stroke="currentColor"
          strokeWidth="2"
        />
        <path
          d="M23.2883 11.2064C25.8906 11.3302 28.0985 9.30713 28.2197 6.68763C28.341 4.06814 26.3298 1.84421 23.7275 1.72035C21.1252 1.5965 18.9173 3.61961 18.796 6.23911C18.6747 8.8586 20.686 11.0825 23.2883 11.2064Z"
          fill="currentColor"
          stroke="currentColor"
          strokeWidth="2"
        />
        <path
          d="M13.8813 9.59139L13.5724 8.9083L13.5714 8.90876L13.8813 9.59139ZM14.7819 9.56723L15.0555 8.86708L15.0555 8.86708L14.7819 9.56723ZM15.445 10.2004L16.1279 9.8897L16.1275 9.88867L15.445 10.2004ZM22.2698 25.3817L21.5869 25.6924L21.5874 25.6934L22.2698 25.3817ZM22.3076 26.3021L21.6032 26.0496L22.3076 26.3021ZM21.6983 26.9716L22.0083 27.6542L22.009 27.6539L21.6983 26.9716ZM10.108 32.2967L10.417 32.9798L10.418 32.9793L10.108 32.2967ZM8.54435 31.6877L7.86142 31.9984L7.86188 31.9994L8.54435 31.6877ZM1.71951 16.5064L2.40245 16.1957L2.40198 16.1947L1.71951 16.5064ZM1.68171 15.586L0.977272 15.3335L1.68171 15.586ZM2.291 14.9165L1.98106 14.2339L1.98039 14.2342L2.291 14.9165ZM17.1512 13.9957L17.8341 13.685L17.8341 13.685L17.1512 13.9957ZM18.0043 15.8934L18.6872 15.5827L18.6872 15.5827L18.0043 15.8934ZM17.5346 16.6785C17.7044 17.0561 18.1478 17.2232 18.525 17.0516C18.9022 16.88 19.0703 16.4347 18.9005 16.0571L17.5346 16.6785ZM14.1903 10.2745C14.2915 10.2281 14.4035 10.2265 14.5084 10.2674L15.0555 8.86708C14.5946 8.68739 14.0616 8.68441 13.5724 8.9083L14.1903 10.2745ZM14.5084 10.2674C14.6141 10.3086 14.7082 10.3919 14.7625 10.5121L16.1275 9.88867C15.9083 9.40319 15.5156 9.04648 15.0555 8.86708L14.5084 10.2674ZM21.5874 25.6934C21.6417 25.8137 21.6424 25.9406 21.6032 26.0496L23.0121 26.5546C23.1798 26.0882 23.1717 25.556 22.9523 25.0699L21.5874 25.6934ZM21.6032 26.0496C21.5641 26.1584 21.488 26.2431 21.3877 26.2893L22.009 27.6539C22.4972 27.429 22.8442 27.0217 23.0121 26.5546L21.6032 26.0496ZM21.3884 26.289L9.79809 31.6141L10.418 32.9793L22.0083 27.6542L21.3884 26.289ZM9.79909 31.6136C9.69783 31.66 9.58589 31.6616 9.48092 31.6207L8.93388 33.021C9.39476 33.2007 9.92776 33.2037 10.417 32.9798L9.79909 31.6136ZM9.48092 31.6207C9.37521 31.5795 9.28111 31.4962 9.22682 31.376L7.86188 31.9994C8.08101 32.4849 8.47374 32.8416 8.93388 33.021L9.48092 31.6207ZM9.22729 31.377L2.40245 16.1957L1.03658 16.8171L7.86142 31.9984L9.22729 31.377ZM2.40198 16.1947C2.34767 16.0744 2.34698 15.9475 2.38614 15.8385L0.977272 15.3335C0.809589 15.7999 0.817653 16.3321 1.03704 16.8182L2.40198 16.1947ZM2.38614 15.8385C2.42529 15.7297 2.50137 15.645 2.60162 15.5988L1.98039 14.2342C1.49213 14.4591 1.14518 14.8664 0.977272 15.3335L2.38614 15.8385ZM2.60094 15.5991L14.1913 10.274L13.5714 8.90876L1.98106 14.2339L2.60094 15.5991ZM14.7621 10.5111L16.4683 14.3064L17.8341 13.685L16.1279 9.8897L14.7621 10.5111ZM16.4683 14.3064L17.3214 16.2041L18.6872 15.5827L17.8341 13.685L16.4683 14.3064ZM18.7606 19.4054L21.5869 25.6924L22.9528 25.071L20.1264 18.784L18.7606 19.4054ZM17.3214 16.2041L17.5346 16.6785L18.9005 16.0571L18.6872 15.5827L17.3214 16.2041Z"
          fill={colors.PRIMARY_GREY_900}
        />
        <path
          d="M5.48047 17.8393L14.2057 13.8635"
          stroke={colors.PRIMARY_GREY_900}
          strokeWidth="1.5"
          strokeLinecap="round"
        />
        <path
          d="M6.51562 19.9319L15.2409 15.9561"
          stroke={colors.PRIMARY_GREY_900}
          strokeWidth="1.5"
          strokeLinecap="round"
        />
        <path
          d="M7.55469 22.0242L16.2799 18.0483"
          stroke={colors.PRIMARY_GREY_900}
          strokeWidth="1.5"
          strokeLinecap="round"
        />
        <path
          d="M18.6548 11.354L18.1429 19.2631C18.1366 19.3604 18.1657 19.4566 18.2246 19.5339C18.2918 19.622 18.3881 19.6743 18.4895 19.6877C18.591 19.7011 18.6975 19.6755 18.7851 19.6079L21.4088 17.5813C21.5469 17.4746 21.7098 17.4139 21.8762 17.4008C22.0427 17.3876 22.2128 17.4221 22.3656 17.5059L25.2095 19.0659C25.2972 19.114 25.3997 19.1273 25.4968 19.1031C25.604 19.0764 25.6903 19.0085 25.7433 18.9203C25.7962 18.8321 25.8157 18.7237 25.7893 18.6158L23.9578 11.1418"
          stroke={colors.PRIMARY_GREY_900}
          strokeWidth="1.5"
        />
        <path
          d="M21.3985 11.9798C23.9963 11.7752 25.9397 9.49024 25.7392 6.87627C25.5387 4.26229 23.2703 2.30913 20.6725 2.51376C18.0747 2.71839 16.1313 5.00332 16.3317 7.6173C16.5322 10.2313 18.8007 12.1844 21.3985 11.9798Z"
          stroke={colors.PRIMARY_GREY_900}
          strokeWidth="1.5"
        />
      </g>
    </symbol>
  )
}

const CertificateStandaloneContent = standalone(CertificateSymbol, ID)

export const Certificate = styled(function CertificateStandaloneComponent(
  props: illustration.SpecificIllustrationProps,
) {
  return (
    <illustration.Illustration {...props} name="certificate">
      <CertificateStandaloneContent />
    </illustration.Illustration>
  )
})``

export const CertificateLightweight = styled(function CertificateComponent(
  props: illustration.SpecificIllustrationProps,
) {
  return (
    <illustration.Illustration {...props} name="certificate">
      {lightweight(ID)}
    </illustration.Illustration>
  )
})``
